import { yupResolver } from '@hookform/resolvers/yup'
import { useState, Fragment } from 'react'
import { useForm } from 'react-hook-form'
import { number, object, string } from 'yup'
import { Dialog, Transition } from '@headlessui/react'
import ContactApis from './apis'
import { PhoneIcon } from '@heroicons/react/outline'
import { ChatIcon } from '@heroicons/react/solid'

const schema = object({
  email: string().email().required(),
  fullname: string().required(),
  phone: number().required(),
  subject: string().required(),
  message: string().required(),
}).required()

const ContactUs = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) })
  const [isOpen, setIsOpen] = useState(false)
  function closeModal() {
    setIsOpen(false)
  }

  function openModal() {
    setIsOpen(true)
  }

  const onSubmit = async ({ fullname, phone, email, subject, message }) => {
    const data = await ContactApis.submit(
      fullname,
      email,
      parseInt(phone),
      subject,
      message,
    )
    if (data) {
      openModal()
      reset()
    }
  }
  const onError = (errors, e) => console.log(errors, e)
  return (
    <div className='align-center  flex h-[100%] min-h-full  bg-theme-turquoise px-5 '>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as='div' className='relative z-10' onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black bg-opacity-25' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                  <Dialog.Title
                    as='h3'
                    className='text-lg font-medium leading-6 text-gray-900'
                  >
                    Form submited
                  </Dialog.Title>
                  <div className='mt-2'>
                    <p className='text-sm text-gray-500'>
                      Hi There!   Thank you for reaching out.   We will get back
                      to you in 2-3 days.   Till then, take care :)  
                      <p>Cheers!  </p>
                      Team Thrive Café
                    </p>
                  </div>

                  <div className='mt-4'>
                    <button
                      type='button'
                      className='inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2'
                      onClick={closeModal}
                    >
                      Got it, thanks!
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <div className='py-custom-50 pt-custom-150  mt-3 flex-[0_0_100%]  '>
        <div className=' mx-auto mb-[10px] h-full max-w-[566px] flex-col  content-between pl-5 pr-12'>
          <div className=' lg:py-15 bg-gray-50 py-5 px-4  sm:w-[full] lg:px-4 lg:pt-10 xl:pr-12'>
            <div className='mx-auto max-w-lg'>
              <h2 className='text-1xl  font-bold tracking-tight text-gray-900 sm:text-3xl'>
                Contact Us
              </h2>

              <dl className='mt-4 text-base text-gray-500'>
                <div className='mt-6'>
                  <dt className='sr-only'>Phone number</dt>
                  <dd className='flex'>
                    <PhoneIcon
                      className='h-6 w-6  text-gray-400'
                      aria-hidden='true'
                    />

                    <span className='ml-3'>+91 9731717225</span>
                  </dd>
                </div>
                <div className='mt-3'>
                  <dt className='sr-only'>Email</dt>
                  <dd className='flex'>
                    <ChatIcon
                      className='h-6 w-6 flex-shrink-0 text-gray-400'
                      aria-hidden='true'
                    />
                    <span className='ml-3'>talk2us@thrivecafe.in</span>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
          <div className='  bg-white py-5  px-4 sm:w-[full] md:w-[full] lg:w-[full]  lg:px-8 xl:pl-12'>
            <div className='mx-auto max-w-lg lg:max-w-none'>
              <form
                action='#'
                method='POST'
                className='grid grid-cols-1 gap-y-6'
                onSubmit={handleSubmit(onSubmit, onError)}
              >
                <div>
                  <label htmlFor='full-name' className='sr-only'>
                    Full name
                  </label>
                  <input
                    type='text'
                    name='full-name'
                    id='full-name'
                    autoComplete='name'
                    className='block w-full rounded-md border-gray-300 py-3 px-4 placeholder-gray-500 shadow-sm focus:border-indigo-500 focus:ring-indigo-500'
                    placeholder='Full name'
                    {...register('fullname')}
                  />
                </div>
                <div>
                  <label htmlFor='email' className='sr-only'>
                    Email
                  </label>
                  <input
                    id='email'
                    name='email'
                    type='email'
                    autoComplete='email'
                    className='block w-full rounded-md border-gray-300 py-3 px-4 placeholder-gray-500 shadow-sm focus:border-indigo-500 focus:ring-indigo-500'
                    placeholder='Email'
                    {...register('email')}
                  />
                </div>
                <div>
                  <label htmlFor='phone' className='sr-only'>
                    Phone
                  </label>
                  <input
                    type='number'
                    name='phone'
                    id='phone'
                    autoComplete='tel'
                    className='block w-full rounded-md border-gray-300 py-3 px-4 placeholder-gray-500 shadow-sm focus:border-indigo-500 focus:ring-indigo-500'
                    placeholder='Phone'
                    {...register('phone')}
                  />
                </div>
                <div>
                  <label htmlFor='message' className='sr-only'>
                    Subject
                  </label>
                  <textarea
                    id='subject'
                    name='subject'
                    rows={4}
                    className='block w-full rounded-md border-gray-300 py-3 px-4 placeholder-gray-500 shadow-sm focus:border-indigo-500 focus:ring-indigo-500'
                    placeholder='Subject'
                    defaultValue={''}
                    {...register('subject')}
                  />
                </div>
                <div>
                  <label htmlFor='message' className='sr-only'>
                    Message
                  </label>
                  <textarea
                    id='message'
                    name='message'
                    rows={4}
                    className='block w-full rounded-md border-gray-300 py-3 px-4 placeholder-gray-500 shadow-sm focus:border-indigo-500 focus:ring-indigo-500'
                    placeholder='Message'
                    defaultValue={''}
                    {...register('message')}
                  />
                </div>
                <div>
                  <button
                    type='submit'
                    className='inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-3 px-5 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ContactUs
